import script from "./ChatInputWrapper.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChatInputWrapper.vue?vue&type=script&setup=true&lang=ts"

import "./ChatInputWrapper.vue?vue&type=style&index=0&id=1320102b&lang=scss&scoped=true"

import exportComponent from "/var/www/briskly/brskl/products/business/app.prod.new/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1320102b"]])

export default __exports__